// extracted by mini-css-extract-plugin
export default {"copyRight":"ZvyDsn48oSuCoga63jmJ","common_bganimation":"cfEg1OlbRo8VUNobySo1"};